/* eslint-disable react/prop-types */
import React from 'react';
import { useFormikContext } from 'formik';

import SelectProduct from '@components/form/SelectProduct';
import SociollaErrorMessage from './SociollaErrorMessage';

function SociollaSelectProduct({ name, onChange, ...otherProps }) {
  const { setFieldValue, errors, touched, values } = useFormikContext();

  return (
    <>
      <SelectProduct
        onChange={async (value) => {
          await setFieldValue(name, value);
          if (onChange) {
            onChange(value);
          }
        }}
        value={values[name]}
        {...otherProps}
      />
      <SociollaErrorMessage error={errors[name]} visible={touched[name]} />
    </>
  );
}

export default SociollaSelectProduct;
